var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-centers"},[_c('button',{staticClass:"swap-btn",class:[
      _vm.disabled ? 'btn-disable' : '',
      _vm._isThemeGame ? 'game-button' : ''
    ],attrs:{"disabled":_vm.disabled},on:{"click":_vm.handleClick}},[_c('span',[_vm._v(_vm._s(_vm.text))])])])}
var staticRenderFns = []

export { render, staticRenderFns }